import {forwardRef} from 'react'

import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {Hero} from '@primer/react-brand'

import {isFeatureEnabled} from '@github-ui/feature-flags'

import type {GenericContent} from '../../../../brand/lib/types/contentful'

import {CtaGroup} from '../../_components/CtaGroup/CtaGroup'

import {EyebrowBanner} from './EyebrowBanner'

type Props = {
  contentfulContent: GenericContent
}

export const HeroContent = forwardRef<HTMLDivElement, Props>(function HeroContent(props, ref) {
  const {contentfulContent} = props
  const {heading, subheading, ctas, content} = contentfulContent.fields

  const isEyebrowBannerEnabled = isFeatureEnabled('site_homepage_eyebrow_banner')

  const eyebrowBannerContent = content?.find(item => item.fields.id === 'heroContentEyebrowBanner') as
    | GenericContent
    | undefined

  return (
    <div ref={ref} className="lp-IntroHero">
      {isEyebrowBannerEnabled && eyebrowBannerContent ? (
        <EyebrowBanner contentfulContent={eyebrowBannerContent} />
      ) : null}

      <Hero className="lp-IntroHero-hero" data-hpc align="center">
        {heading ? <Hero.Heading size="2">{heading}</Hero.Heading> : null}

        {subheading ? <Hero.Description size="300">{documentToPlainTextString(subheading)}</Hero.Description> : null}
      </Hero>

      {ctas ? <CtaGroup contentfulContent={ctas} location="hero" /> : null}
    </div>
  )
})

try{ HeroContent.displayName ||= 'HeroContent' } catch {}